/**
 * Front-end script for the TikTok block.
 * Handles the play button click: injects the oEmbed HTML into the page,
 * loads the TikTok embed script if not already present, and swaps out
 * the thumbnail preview once the iframe is fully loaded.
 */
document.addEventListener('DOMContentLoaded', () => {
	const tiktokVideos = document.querySelectorAll('.wp-block-superprof-tiktok-block');

	tiktokVideos.forEach((tiktokVideo) => {
		const tiktokContainer = tiktokVideo.querySelector('.tiktok-container');
		const playButton = tiktokVideo.querySelector('.play-button');

		playButton.addEventListener('click', () => {

			playButton.classList.add('loading'); // Show a loading state while the embed initialises

			// The embed HTML string was saved as a data attribute on the preview element
			const embedHtml = tiktokVideo.querySelector('.tiktok-preview').getAttribute('data-embed-html');
			if (embedHtml) {
				// Insert the TikTok blockquote embed markup after the thumbnail container
				tiktokContainer.insertAdjacentHTML('afterend', embedHtml);
				// Hide the thumbnail to avoid visual overlap with the iframe
				tiktokContainer.classList.add('embedded');

				if (typeof window.tiktokEmbedInit === 'function') {
					// TikTok embed script already loaded: initialise the new embed manually
					window.tiktokEmbedInit();
					waitForIframe(tiktokVideo);
				} else {
					// Script not yet loaded: inject it dynamically, then initialise
					const script = document.createElement('script');
					script.src = 'https://www.tiktok.com/embed.js';
					script.async = true;
					script.onload = () => {
						if (typeof window.tiktokEmbedInit === 'function') {
							window.tiktokEmbedInit();
						}
						waitForIframe(tiktokVideo);
					};
					document.body.appendChild(script);
				}
			}
		});
	});

	/**
	 * Polls for the TikTok iframe inside the given video wrapper.
	 * Once found, waits for it to load and then fades out and removes the thumbnail container.
	 * @param {HTMLElement} tiktokVideo - The block's root element.
	 */
	function waitForIframe(tiktokVideo) {
		const iframe = tiktokVideo.querySelector('iframe');
		if (iframe) {
			// Add event listener for the iframe load event
			iframe.addEventListener('load', () => {
				setTimeout(() => {
					// Once the iframe is loaded, fade out and remove the thumbnail container
					const tiktokContainer = tiktokVideo.querySelector('.tiktok-container');
					tiktokContainer.classList.add('fade');
					tiktokContainer.remove();
				}, 500);  // Short delay lets the fade CSS transition play out
			});
		} else {
			// Iframe not yet injected by TikTok's script — check again in 100ms
			setTimeout(() => waitForIframe(tiktokVideo), 100);
		}
	}
});
